import { useFormikContext } from "formik";
import "../../../assets/style/inscription.scss";
import CheckBoxGroup from "../../../components/FormGroups/CheckBoxGroup";
import { Member } from "../../../entities/entities";
import { isMinor } from "../../../toolServices/helper";

const AccepterComponent: React.FC = () => {
    const formikContext = useFormikContext<Member>();

    const showMineurAutonomeCheckbox: boolean =
        isMinor(formikContext.values.etatCivil.birthDate) && formikContext.values.escalade.creneau === "Adultes";

    const LABEL1 = (
        <div>
            J'ai pris connaissance des statuts et du{" "}
            <a target="_blank" rel="noreferrer" href="http://www.gest77.fr/?page_id=41">
                règlement de l'association, et de la salle d'escalade.
            </a>
            <br />
            Je les accepte sans réserves.
            <br /> Je renonce à mon droit à l'image dans le cadre des activités de l'association.
        </div>
    );

    const LABEL2 = (
        <div>
            J'autorise mon enfant à participer aux créneaux de pratique libre du club. J'autorise mon enfant à arriver et repartir seul du gymnase, y compris
            avant la fin de la séance. Je reconnais que les trajets domicile–gymnase sont sous ma responsabilité à sa sortie de la séance.
        </div>
    );
    //console.log("ERRORS : " + JSON.stringify(formikContext.errors, null, 2));

    return (
        <div className="container">
            <div className="section">Acceptation des conditions</div>
            <div className="row">
                <div className="col-100">
                    <CheckBoxGroup
                        id="mineurAutonome"
                        label={LABEL2}
                        value={formikContext.values.mineurAutonome}
                        hidden={!showMineurAutonomeCheckbox}
                        onChange={(newValue: boolean) => {
                            const m: Member = { ...formikContext.values, mineurAutonome: newValue };
                            formikContext.setValues(m, true);
                        }}
                    />
                    <span className="error-field">{formikContext.errors?.mineurAutonome as string}</span>
                    <CheckBoxGroup
                        id="accept1"
                        label={LABEL1}
                        value={formikContext.values.meta.accepted}
                        onChange={(newValue: boolean) => {
                            const m: Member = { ...formikContext.values, meta: { ...formikContext.values.meta, accepted: newValue } };
                            formikContext.setValues(m, true);
                        }}
                    />
                    <span className="error-field">{formikContext.errors?.meta?.accepted as string}</span>
                </div>
            </div>

            <div>&nbsp;</div>
            <div>Le GEST s'engage à ne communiquer aucune des informations précédentes à aucun organisme tiers.</div>
        </div>
    );
};
export default AccepterComponent;
